import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AddContactRequest, EditContactRequest } from '~api/address_book';

import { AddressBookApiInstance } from '~src/main/api';
import { useSiteId } from '~src/main/hooks/useSiteId';

import { useAddressBookQueryKey } from './queries';

export function useAddressBookCreateMutation() {
  const siteId = useSiteId();

  const queryKey = useAddressBookQueryKey();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: Omit<AddContactRequest, 'site_id'>) =>
      AddressBookApiInstance.addressBookAddContact({
        site_id: siteId,
        ...data,
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: queryKey.lists(),
      });
    },
  });
}

export function useAddressBookRemoveMutation() {
  const siteId = useSiteId();

  const queryKey = useAddressBookQueryKey();
  const queryClient = useQueryClient();

  const mutationFn = AddressBookApiInstance.addressBookDeleteContacts;

  return useMutation({
    mutationFn: ({ contact_ids }: { contact_ids: string[] }) => mutationFn({ contact_ids, site_id: siteId }),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: queryKey.lists(),
      });
    },
  });
}

export function useAddressBookUpdateMutation() {
  const siteId = useSiteId();

  const queryKey = useAddressBookQueryKey();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: Omit<EditContactRequest, 'site_id'>) =>
      AddressBookApiInstance.addressBookEditContact({
        site_id: siteId,
        ...data,
      }),
    onSuccess: ({ data: { contact } }) => {
      void queryClient.invalidateQueries({
        queryKey: queryKey.lists(),
      });
      void queryClient.invalidateQueries({
        queryKey: queryKey.detail(contact?.id),
      });
    },
  });
}
